import SwiperModal from '../../components/swiperModal/';
function showSwiper(data) {
  if (!data || JSON.stringify(data) == '[]' || JSON.stringify(data) == '{}') return;
  new SwiperModal({
    imgList: data,
    wrapper: this.$container.get(0),
  });
}
export default {
  showSwiper,
};
